'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRouter = require('react-router');

var _reactBootstrap = require('react-bootstrap');

var _utils = require('helpers/utils');

var _components2 = require('components');

require('./AuthOneClickView.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    AuthOneClickView: {
        displayName: 'AuthOneClickView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Auth/default/AuthOneClickView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var AuthOneClickView = _wrapComponent('AuthOneClickView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(AuthOneClickView, _Component);

    function AuthOneClickView(props, context) {
        (0, _classCallCheck3.default)(this, AuthOneClickView);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AuthOneClickView.__proto__ || (0, _getPrototypeOf2.default)(AuthOneClickView)).call(this, props, context));

        _this.refInput = function (input) {
            _this.inputLogin = input;
        };

        _this.showError = function () {
            var _this$props = _this.props,
                loginError = _this$props.loginError,
                loginErrorCode = _this$props.loginErrorCode,
                lang = _this$props.lang;


            if (loginError) {
                if (loginErrorCode === null || loginErrorCode === undefined) {
                    return _react3.default.createElement(
                        _reactBootstrap.Alert,
                        { bsStyle: 'danger', className: 'inner-right-xs' },
                        lang['store.auth_one_click.default_alert']
                    );
                } else {
                    return _react3.default.createElement(
                        _reactBootstrap.Alert,
                        { bsStyle: 'danger', className: 'inner-right-xs' },
                        lang[loginError]
                    );
                }
            }

            return '';
        };

        _this.onClickRegistration = function (event) {
            event.preventDefault();
            if (_this.props.onClickRegistration) {
                _this.props.onClickRegistration(event);
            }
        };

        _this.onClickOneClick = function (event) {
            event.preventDefault();
            _this.props.onClickOneClick(event);
        };

        _this.onClickConfirmOneClick = function (event) {
            event.preventDefault();
            _this.props.onClickConfirmOneClick(event);
        };

        _this.onClickPassRecovery = function (event) {
            event.preventDefault();
            if (_this.props.onClickPassRecovery) {
                _this.props.onClickPassRecovery(event);
            }
        };

        _this.showCaptcha = function () {
            if (_this.props.showCaptcha) {
                return _react3.default.createElement(
                    _reactBootstrap.FormGroup,
                    null,
                    _this.props.showCaptcha()
                );
            }

            return '';
        };

        _this.showOneClickConfirm = function () {
            var lang = _this.props.lang;


            if (_this.props.codeSendFor !== '') {
                if (_this.props.codeSendFor === 'email') {
                    var _description = lang['store.auth_one_click.confirm.description_email'];
                    var _header = lang['store.auth_one_click.confirm.header_email_in_use'];
                    if (_this.props.newUser) {
                        _header = lang['store.auth_one_click.confirm.header_guest'];
                    }
                    return _react3.default.createElement(
                        'div',
                        { className: 'bordered' },
                        _react3.default.createElement(
                            'h2',
                            null,
                            _header
                        ),
                        _react3.default.createElement(
                            _reactBootstrap.FormGroup,
                            null,
                            _description
                        ),
                        _react3.default.createElement(
                            _reactBootstrap.FormGroup,
                            { style: { marginBottom: '0px' } },
                            _react3.default.createElement(
                                _reactBootstrap.ControlLabel,
                                null,
                                lang['store.auth_one_click.confirm.enter_email_code'],
                                '*'
                            )
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12 col-sm-7 text-right no-padding' },
                            _react3.default.createElement(_reactBootstrap.FormControl, {
                                type: (0, _utils.isMobileDevice)() ? "number" : "text",
                                pattern: '\\d*',
                                placeholder: '1234',
                                value: _this.props.emailCode,
                                onChange: function onChange(e) {
                                    if ((0, _utils.validateNumeric)(e.target.value)) {
                                        _this.props.changeField('emailCode')(e);
                                    }
                                }
                            })
                        ),
                        _react3.default.createElement(
                            'div',
                            { className: 'col-xs-12 col-sm-5 text-right inline_block button_width_100' },
                            _react3.default.createElement(
                                _reactBootstrap.Button,
                                {
                                    type: 'submit',
                                    bsStyle: 'primary',
                                    className: 'form-control',
                                    disabled: _this.props.disabledSubmitOneClick,
                                    onClick: _this.onClickConfirmOneClick
                                },
                                lang['store.auth_one_click.confirm.confirm']
                            )
                        ),
                        _react3.default.createElement(
                            _reactBootstrap.FormGroup,
                            { style: { paddingTop: '26px', marginTop: '20px' } },
                            _this.renderTimer()
                        )
                    );
                }
                var description = lang['store.auth_one_click.confirm.description_phone'];
                var header = lang['store.auth_one_click.confirm.header_phone_in_use'];
                if (_this.props.newUser) {
                    header = lang['store.auth_one_click.confirm.header_guest'];
                }
                return _react3.default.createElement(
                    'div',
                    { className: 'bordered' },
                    _react3.default.createElement(
                        'h2',
                        null,
                        header
                    ),
                    _react3.default.createElement(
                        _reactBootstrap.FormGroup,
                        null,
                        description
                    ),
                    _react3.default.createElement(
                        _reactBootstrap.FormGroup,
                        { style: { marginBottom: '0px' } },
                        _react3.default.createElement(
                            _reactBootstrap.ControlLabel,
                            null,
                            lang['store.auth_one_click.confirm.enter_sms_code'],
                            '*'
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-7 text-right no-padding' },
                        _react3.default.createElement(_reactBootstrap.FormControl, {
                            type: (0, _utils.isMobileDevice)() ? "number" : "text",
                            pattern: '\\d*',
                            placeholder: '1234',
                            value: _this.props.phoneCode,
                            onChange: function onChange(e) {
                                if ((0, _utils.validateNumeric)(e.target.value)) {
                                    _this.props.changeField('phoneCode')(e);
                                }
                            }
                        })
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-5 text-right inline_block button_width_100' },
                        _react3.default.createElement(
                            _reactBootstrap.Button,
                            {
                                type: 'submit',
                                bsStyle: 'primary',
                                className: 'form-control',
                                disabled: _this.props.disabledSubmitOneClick,
                                onClick: _this.onClickConfirmOneClick
                            },
                            lang['store.auth_one_click.confirm.confirm']
                        )
                    ),
                    _react3.default.createElement(
                        _reactBootstrap.FormGroup,
                        { style: { paddingTop: '26px', marginTop: '20px' } },
                        _this.renderVoiceCode()
                    ),
                    _react3.default.createElement(
                        _reactBootstrap.FormGroup,
                        null,
                        _this.renderTimer()
                    )
                );
            }

            return _react3.default.createElement(
                'div',
                { className: 'bordered' },
                _react3.default.createElement(
                    'form',
                    { name: 'loginOneClick', autoComplete: 'on', className: 'login-form' },
                    _react3.default.createElement(
                        'h2',
                        null,
                        lang['store.auth_one_click.confirm.header_guest']
                    ),
                    _react3.default.createElement(
                        _reactBootstrap.FormGroup,
                        null,
                        lang['store.auth_one_click.confirm.cta']
                    ),
                    _react3.default.createElement(
                        _reactBootstrap.FormGroup,
                        { style: { marginBottom: '0px' } },
                        _react3.default.createElement(
                            _reactBootstrap.ControlLabel,
                            { className: 'no-padding' },
                            lang['store.login.phone_or_email']
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-8 text-right no-padding' },
                        _react3.default.createElement(_reactBootstrap.FormControl, {
                            type: 'text',
                            name: 'username',
                            controlId: 'login',
                            value: _this.props.login,
                            onChange: _this.props.changeField('login'),
                            placeholder: lang['store.login.email_or_phone_placeholder']
                        })
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'col-xs-12 col-sm-3 text-right inlinediv' },
                        _react3.default.createElement(
                            _reactBootstrap.Button,
                            {
                                type: 'submit',
                                className: 'le-button inlinebutton g-recaptcha',
                                disabled: _this.props.disabledSubmitOneClick,
                                onClick: _this.onClickOneClick
                            },
                            lang['store.auth_one_click.next']
                        )
                    ),
                    _this.showCaptcha(),
                    _react3.default.createElement(_reactBootstrap.FormGroup, { className: 'inlineform' }),
                    _react3.default.createElement(_reactBootstrap.FormGroup, null)
                )
            );
        };

        _this.renderVoiceCode = function () {
            if (_this.props.codeSendFor === 'phone') {
                return _react3.default.createElement(_components2.VoiceCode, {
                    login: _this.props.login,
                    source: 'registration',
                    showAlert: _this.showOuterAlert,
                    whiteList: false
                });
            }
            return null;
        };

        _this.renderTimer = function () {
            var lang = _this.props.lang;

            var retry_in = lang['store.timer.retry'] + ' ';
            var seconds = ' ' + lang['store.timer.sec'] + ' ';

            return _react3.default.createElement(
                _reactBootstrap.FormGroup,
                null,
                _react3.default.createElement(
                    'div',
                    { className: 'voice_wrap text-center' },
                    _this.props.timeToResentCode > 0 ? _react3.default.createElement(
                        'p',
                        { id: 'voice_call_time_wrap', className: 'active' },
                        retry_in,
                        _react3.default.createElement(
                            'span',
                            { id: 'voice_call_time active' },
                            _this.props.timeToResentCode
                        ),
                        seconds
                    ) : _react3.default.createElement(
                        _components2.Preloader,
                        { classNames: 'mini_preload', preload: _this.props.preloader },
                        _react3.default.createElement(
                            'a',
                            { id: 'get_voice_call', href: '#', onClick: _this.props.onClickResendCode },
                            lang['store.auth_one_click.timer.resend']
                        )
                    )
                )
            );
        };

        _this.showOuterAlert = function (alert) {
            // this.setState({outerAlert: alert});
        };

        _this.handlePhoneChange = function (phone, country) {
            _this.props.changeField('login')(null, phone);
        };

        _this.setActiveClick = function (key) {
            return function (e) {
                var elem = document.getElementsByName('inset');
                elem.forEach(function (item) {
                    item.className = '';
                });
                document.getElementById(key).className = 'checked';
            };
        };

        _this.inputLogin = null;

        _this.context.registerEvent('onEntering', function () {
            if (_this.inputLogin) {
                _reactDom2.default.findDOMNode(_this.inputLogin).focus();
            }
        });
        return _this;
    }

    (0, _createClass3.default)(AuthOneClickView, [{
        key: 'render',
        value: function render() {
            var lang = this.props.lang;


            if (this.props.orderInOneClick) {
                return _react3.default.createElement(
                    _components2.Preloader,
                    { preload: this.props.preload },
                    _react3.default.createElement(
                        'div',
                        { className: 'tabs' },
                        _react3.default.createElement('input', { type: 'radio', name: 'inset', value: '', id: 'tab_1', className: 'checked' }),
                        _react3.default.createElement(
                            'label',
                            { htmlFor: 'tab_2', onClick: this.setActiveClick('tab_1') },
                            lang['store.auth_one_click.one_click_purchase']
                        ),
                        _react3.default.createElement('input', { type: 'radio', name: 'inset', value: '', id: 'tab_2' }),
                        _react3.default.createElement(
                            'label',
                            { htmlFor: 'tab_1', onClick: this.setActiveClick('tab_2') },
                            lang['store.auth_one_click.sign_in_and_buy']
                        ),
                        _react3.default.createElement(
                            'div',
                            { id: 'txt_1' },
                            _react3.default.createElement(
                                'main',
                                { id: 'authentication' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'container__' },
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'row' },
                                        _react3.default.createElement(
                                            'div',
                                            { className: 'col-md-12' },
                                            this.showError(),
                                            _react3.default.createElement(
                                                'section',
                                                { id: 'one-click-form', className: 'sign-in' },
                                                this.showOneClickConfirm()
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        _react3.default.createElement(
                            'div',
                            { id: 'txt_2' },
                            _react3.default.createElement(
                                'main',
                                { id: 'authentication' },
                                _react3.default.createElement(
                                    'div',
                                    { className: 'container__' },
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'row' },
                                        _react3.default.createElement(
                                            'div',
                                            { className: 'col-md-12' },
                                            this.showError(),
                                            _react3.default.createElement(
                                                'section',
                                                { id: 'auth-form', className: 'sign-in' },
                                                _react3.default.createElement(
                                                    'div',
                                                    { className: 'bordered' },
                                                    _react3.default.createElement(
                                                        'form',
                                                        { name: 'login', autoComplete: 'on', className: 'login-form',
                                                            onSubmit: this.props.onSubmit },
                                                        _react3.default.createElement(
                                                            _reactBootstrap.FormGroup,
                                                            null,
                                                            lang['store.auth_one_click.sign_in_and_make_order']
                                                        ),
                                                        _react3.default.createElement(
                                                            _reactBootstrap.FormGroup,
                                                            { controlId: 'username',
                                                                validationState: this.props.validateField('login') },
                                                            _react3.default.createElement(
                                                                _reactBootstrap.ControlLabel,
                                                                null,
                                                                lang['store.login.phone_or_email']
                                                            ),
                                                            _react3.default.createElement(_reactBootstrap.FormControl, {
                                                                type: 'text',
                                                                name: 'username',
                                                                controlId: 'login',
                                                                value: this.props.login,
                                                                onChange: this.props.changeField('login'),
                                                                placeholder: lang['store.login.email_or_phone_placeholder']
                                                            })
                                                        ),
                                                        _react3.default.createElement(
                                                            _reactBootstrap.FormGroup,
                                                            {
                                                                validationState: this.props.validateField('password'),
                                                                controlId: 'password' },
                                                            _react3.default.createElement(
                                                                _reactBootstrap.ControlLabel,
                                                                null,
                                                                lang['login.password']
                                                            ),
                                                            _react3.default.createElement(_reactBootstrap.FormControl, {
                                                                type: 'password',
                                                                name: 'password',
                                                                controlId: 'password',
                                                                autoComplete: 'password',
                                                                placeholder: lang['login.password'],
                                                                value: this.props.password,
                                                                onChange: this.props.changeField('password') })
                                                        ),
                                                        this.showCaptcha(),
                                                        _react3.default.createElement(
                                                            _reactBootstrap.FormGroup,
                                                            null,
                                                            _react3.default.createElement(
                                                                _reactBootstrap.Button,
                                                                {
                                                                    type: 'submit',
                                                                    bsStyle: 'primary',
                                                                    className: 'form-control',
                                                                    disabled: this.props.disabledSubmit
                                                                },
                                                                lang['store.auth_one_click.enter']
                                                            )
                                                        ),
                                                        _react3.default.createElement(
                                                            _reactBootstrap.FormGroup,
                                                            null,
                                                            _react3.default.createElement(
                                                                'div',
                                                                { className: 'text-center to_page_passrecovery' },
                                                                _react3.default.createElement(
                                                                    'a',
                                                                    { onClick: this.onClickPassRecovery },
                                                                    lang['login.forgotYourPassword']
                                                                )
                                                            )
                                                        ),
                                                        _react3.default.createElement(
                                                            _reactBootstrap.FormGroup,
                                                            null,
                                                            _react3.default.createElement(
                                                                'div',
                                                                { className: 'text-center to-page-registration' },
                                                                _react3.default.createElement(
                                                                    _reactRouter.Link,
                                                                    { to: '/registration',
                                                                        onClick: this.onClickRegistration },
                                                                    lang['store.common.sign_up']
                                                                )
                                                            )
                                                        )
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                );
            }
            return _react3.default.createElement(
                _components2.Preloader,
                { preload: this.props.preload },
                _react3.default.createElement(
                    'main',
                    { id: 'authentication' },
                    _react3.default.createElement(
                        'div',
                        { className: 'container__' },
                        _react3.default.createElement(
                            'div',
                            { className: 'row' },
                            _react3.default.createElement(
                                'div',
                                { className: 'col-md-12' },
                                this.showError(),
                                _react3.default.createElement(
                                    'section',
                                    { id: 'auth-form', className: 'sign-in' },
                                    _react3.default.createElement(
                                        'div',
                                        { className: 'bordered' },
                                        _react3.default.createElement(
                                            'form',
                                            { name: 'login', autoComplete: 'on', className: 'login-form', onSubmit: this.props.onSubmit },
                                            _react3.default.createElement(
                                                _reactBootstrap.FormGroup,
                                                { controlId: 'username', validationState: this.props.validateField('login') },
                                                _react3.default.createElement(
                                                    _reactBootstrap.ControlLabel,
                                                    null,
                                                    lang['store.login.phone_or_email']
                                                ),
                                                _react3.default.createElement(_reactBootstrap.FormControl, {
                                                    type: 'text',
                                                    name: 'username',
                                                    controlId: 'login',
                                                    value: this.props.login,
                                                    onChange: this.props.changeField('login'),
                                                    placeholder: lang['store.login.email_or_phone_placeholder']
                                                })
                                            ),
                                            _react3.default.createElement(
                                                _reactBootstrap.FormGroup,
                                                { validationState: this.props.validateField('password'), controlId: 'password' },
                                                _react3.default.createElement(
                                                    _reactBootstrap.ControlLabel,
                                                    null,
                                                    lang['login.password']
                                                ),
                                                _react3.default.createElement(_reactBootstrap.FormControl, {
                                                    type: 'password',
                                                    name: 'password',
                                                    controlId: 'password',
                                                    autoComplete: 'password',
                                                    placeholder: lang['login.password'],
                                                    value: this.props.password,
                                                    onChange: this.props.changeField('password') })
                                            ),
                                            this.showCaptcha(),
                                            _react3.default.createElement(
                                                _reactBootstrap.FormGroup,
                                                null,
                                                _react3.default.createElement(
                                                    _reactBootstrap.Button,
                                                    {
                                                        type: 'submit',
                                                        bsStyle: 'primary',
                                                        className: 'form-control g-recaptcha',
                                                        disabled: this.props.disabledSubmit
                                                    },
                                                    lang['store.auth_one_click.enter']
                                                )
                                            ),
                                            _react3.default.createElement(
                                                _reactBootstrap.FormGroup,
                                                null,
                                                _react3.default.createElement(
                                                    'div',
                                                    { className: 'text-center to_page_passrecovery' },
                                                    _react3.default.createElement(
                                                        'a',
                                                        { onClick: this.onClickPassRecovery },
                                                        lang['login.forgotYourPassword']
                                                    )
                                                )
                                            ),
                                            _react3.default.createElement(
                                                _reactBootstrap.FormGroup,
                                                null,
                                                _react3.default.createElement(
                                                    'div',
                                                    { className: 'text-center to-page-registration' },
                                                    _react3.default.createElement(
                                                        _reactRouter.Link,
                                                        { to: '/registration', onClick: this.onClickRegistration },
                                                        lang['store.common.sign_up']
                                                    )
                                                )
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);
    return AuthOneClickView;
}(_react2.Component), _class.propTypes = {
    validateField: _react2.PropTypes.func.isRequired,
    showCaptcha: _react2.PropTypes.func,
    lang: _react2.PropTypes.object
}, _class.contextTypes = {
    registerEvent: _react2.PropTypes.func
}, _temp));

exports.default = AuthOneClickView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth/default/AuthOneClickView.jsx
// module id = 1607
// module chunks = 0